// removed by extract-text-webpack-plugin
module.exports = {"home":"home__5d1SS","content":"content__2yhpg","back":"back__EqDCS","heading":"heading__a02_8","options":"options__2QHlq","option-base":"option-base__14wKt","name":"name__2RYTT","details":"details__35P1u","emoji":"emoji__3C-bT","link-container":"link-container__3bE-b","delete-link":"delete-link__IKGEY","button-copy":"button-copy__3V42o"};


//////////////////
// WEBPACK FOOTER
// ./routes/teams/inviteMembers/style.css
// module id = rzbb
// module chunks = 14